<template>
  <div class="wrapp-pk-store position-relative">
    <div class="store-selected" v-if="selectedBoutique">
      <div class="address-wrapper">
        <div class="wrapp-icon">
          <svg class="o-icon"><use xlink:href="#pin"></use></svg>
        </div>
        <div class="wrapp-address">
          <span class="address">{{currentStoreAddress}}</span>
        </div>
        <div class="wrapp-action">
          <button class="btn btn-icon btn-icon-no-border" @click.prevent="resetCurrentStore">
            <svg class="o-icon"><use xlink:href="#close"></use></svg>
          </button>
        </div>
      </div>
    </div>
    <template v-else>
      <input name="boutique-selection" type="hidden" :value="selectedBoutique" v-validate="'required'" />
      <div class="wrapp-autocomplete-input">
        <b-input-group id="groupStoreAutoComplete">
          <gmap-autocomplete
          class="form-control"
          ref="autocompleteController"
          @place_changed="setPlace"
          :value="placeSearched"
          :options="{
            types: ['(cities)']
          }"
          :placeholder="$t('search.by-city')"
          :selectFirstOnEnter="true">
          </gmap-autocomplete>
          <b-input-group-append>
            <div class="icons-wrapper">
              <button class="btn btn-icon btn-icon-no-border" v-show="!placeSearched.length">
                <svg class="o-icon"><use xlink:href="#search"></use></svg>
              </button>
              <button class="btn btn-icon btn-icon-no-border" v-show="placeSearched.length" @click.prevent="resetInput">
                <svg class="o-icon stroke-black"><use xlink:href="#close-small"></use></svg>
              </button>
            </div>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :class="{ 'd-block': errors.has('boutique-selection') }" class="position-relative">
          <span>{{ $t('pickup.select-store') }}</span>
        </b-form-invalid-feedback>
      </div>
      <div class="stores-list">
        <search-stores :searchResponse="stores" :inputText="placeSearched" :isCheckoutMode="true" />
      </div>
    </template>
    <absolute-loader :showLoader="showLoader" />
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import SearchStores from 'theme/components/Search/manageCriteria/Stores'

export default {
  name: 'StorePicker',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      showLoader: false,
      selectedBoutique: this.$store.getters['userAdmin/getCurrent'],
      placeSearched: '',
      hasSearched: false,
      stores: []
    }
  },
  computed: {
    currentStoreAddress () {
      if (Object.keys(this.selectedBoutique).length) {
        return `${this.selectedBoutique.address}, ${this.selectedBoutique.city}, ${this.selectedBoutique.region} – ${this.selectedBoutique.country}`
      } else {
        return false
      }
    }
  },
  methods: {
    resetCurrentStore () {
      this.selectedBoutique = ''
      global.$cookies.set('pickup-store-code', '')
    },
    resetInput () {
      this.placeSearched = ''
      this.searchStores(this.placeSearched)
    },
    setPlace (place) {
      if (!place) return
      // reset input
      this.placeSearched = place.formatted_address
      this.hasSearched = true
      let inputText = ''
      let hasCoordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }
      this.searchStores(inputText, hasCoordinates)
    },
    searchStores (searchCriteria, hasCoordinates = false) {
      this.showLoader = true
      return this.$store.dispatch('search/searchStores', { inputText: searchCriteria, hasCoordinates })
        .then((res) => {
          this.stores = res.filter(store => store.click_and_collect)
        })
        .finally(() => {
          this.showLoader = false
        })
    },
    setCurrentStore (store) {
      if (store) {
        this.selectedBoutique = store
        global.$cookies.set('pickup-store-code', store.code)
      }
      return this.selectedBoutique
    },
    findActiveStore () {
      if (this.currentBoutique) {
        this.selectedBoutique = { ...this.currentBoutique }
      }
      this.setCurrentStore(this.selectedBoutique)
    },
    getStorePickup () {
      // look for active store
      this.showLoader = true
      return this.$store.dispatch('storeLocator/getStorePickup')
        .then((res) => {
          this.stores = res
          this.findActiveStore()
        })
        .finally(() => {
          this.showLoader = false
        })
    }
  },
  mounted () {
    if (process.client) {
      this.getStorePickup()
    }
    EventBus.$on('storePickup:selectStore', this.setCurrentStore)
  },
  destroyed () {
    EventBus.$off('storePickup:selectStore', this.setCurrentStore)
  },
  components: {
    AbsoluteLoader,
    SearchStores
  }
}
</script>
